import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
declare let window;
@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss']
})
export class ErrorPageComponent implements OnInit {

  constructor(private router:Router) { }

  ngOnInit() {
  }

  onReturnClick():void{
    const hostName = window.location.href.replace("#/error", "");
    window.location = hostName;
  }


}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/components/error-page/error-page.component.ts